import React from 'react';
import { useFieldValueFields } from './dashboard-widget-setting/useFieldValueFields';

export const WidgetDisplayContext = React.createContext<{
  reportFields: { [key: string]: string };
}>({
  reportFields: {},
});

export const WidgetDisplayContextProvider = ({ children }: { children: React.ReactElement }) => {
  const fieldValueFields = useFieldValueFields();
  const reportFields = React.useMemo(
    () =>
      [...fieldValueFields.reporting, ...fieldValueFields.tasks, ...fieldValueFields.forms].reduce(
        (acc, field) => ({ ...acc, [field.fieldId]: field.name }),
        {} as { [key: string]: string }
      ),
    [fieldValueFields]
  );

  return <WidgetDisplayContext.Provider value={{ reportFields }}>{children}</WidgetDisplayContext.Provider>;
};
